// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
  <sub-header header="'Issue checkbook'"></sub-header>

    <!-- Product information -->
    <div class="info info--deposit">
      <div class="info-detail">
        <span class="key">Product name:</span>
        <span class="value">{{\$ctrl.account.productName}}
          </span>
      </div>
      <div class="info-detail">
        <span class="key">Available balance:</span>
        <span class="value">{{\$ctrl.account.balance | nxCurrency}}</span>
      </div>
    </div>

  <div class="alert alert--danger" ng-if="\$ctrl.brstn == null && \$ctrl.isPchcDirectClearing">
    BRSTN is not configured to branch. Please check branch configuration.
  </div>

  <div class="alert alert--danger"
       ng-if="\$ctrl.isPchcDirectClearing && \$ctrl.accountNumber.length !== \$ctrl.checkbookAccountNumberLength">
    Invalid account number length.
  </div>

    <form name="\$ctrl.transactionForm">

      <table class="misc-transaction__table table table--generate-row-ids">
        <tbody>
        <tr ng-if="!\$ctrl.isPchcDirectClearing">
          <td></td>
          <td>Depository account</td>
          <td>
            <selectize
              required
              options="\$ctrl.depositoryAccounts"
              config="\$ctrl.depositoryAccountSelectConfig"
              ng-model="\$ctrl.checkbook.depositoryAccountId"
              ng-change="\$ctrl.onDepositoryAccountChange()">
            </selectize>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>{{\$ctrl.isPchcDirectClearing ? 'Account number:' : 'Depository account number:'}}</td>
          <td>
            <input
              ng-disabled="!\$ctrl.isPchcDirectClearing"
              required
              type="text"
              ui-mask="999999999999"
              ng-minlength="\$ctrl.checkbookAccountNumberLength"
              ng-maxlength="\$ctrl.checkbookAccountNumberLength"
              ng-model="\$ctrl.accountNumber"/>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>{{\$ctrl.isPchcDirectClearing ? 'Branch BRSTN:' : 'Depository account BRSTN:'}}</td>
          <td>
            <input
              disabled
              required
              type="text"
              minlength="9"
              maxlength="9"
              ui-mask="999999999"
              ng-model="\$ctrl.brstn"/>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Checkbook number:</td>
          <td>
            <input
              class="value"
              type="text"
              required
              ng-model="\$ctrl.checkbook.number"
              ng-disabled="\$ctrl.isPchcDirectClearing"
              maxlength="32">
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Checkbook type:</td>
          <td>
            <select
              required
              class="form-control"
              ng-model="\$ctrl.checkbook.type"
              ng-options="t.value as t.label for t in [{label: 'Individual', value: 'INDIVIDUAL'}, {label: 'Commercial', value: 'COMMERCIAL'}]"
              ng-change="\$ctrl.onTypeChange(\$ctrl.checkbook.type)">
            </select>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Number of checks:</td>
          <td>
            <input
              class="value"
              type="number"
              required
              ng-model="\$ctrl.checkbook.checksCount"
              min="1"
              max="5000">
          </td>
        </tr>
        <tr>
          <td></td>
          <td>First check number:</td>
          <td>
            <input
              class="value"
              type="text"
              required
              ng-model="\$ctrl.checkbook.startNumber"
              ng-change="\$ctrl.onFirstCheckNumberChange()"
              ng-pattern="/^[0-9]*\$/"
              >
          </td>
        </tr>
        </tbody>
      </table>

      <div class="buttons">
        <button
          class="btn btn-warning"
          ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button
          class="btn btn-success"
          ng-click="\$ctrl.issue()"
          ng-disabled="\$ctrl.transactionForm.\$invalid">
          Issue
        </button>
      </div>
    </form>

</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/checkbook/issue/checkbook-issue.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;